import createPersistedState from 'vuex-persistedstate'

export default ({ store }) => {
	createPersistedState({
		key: 'vuex-portal',
		storage: window.localStorage,
		paths: ['auth.user']
	})(store)
	createPersistedState({
		key: 'vuex-portal-session',
		storage: window.sessionStorage,
		paths: ['user.utm', 'user.geo', 'user.location', 'teams.nearBy.requestedCache', 'teams.vidswap', 'events.sharedToken', 'events.history', 'events.userFeedbackRate', 'events.tagsBubble', 'events.closedFeedbackQuantity', 'analytics-popup.analyticsPopupShown', 'products.wizardSelection']
	})(store)
}
